import { inpayEnv } from "../env";
import { inpayLocale } from "../locale";
var purchaseHistory = {
  /**
   * 구매내역 페이지 URL을 생성합니다.
   * 
   * @description
   * 웹 토큰을 기반으로 마켓을 판별하고, 해당 마켓의 구매내역 페이지 URL을 생성합니다.
   * 
   * @param {Object} params - URL 생성에 필요한 파라미터
   * @param {string} params.webToken - 웹 토큰
   * @param {string} [params.clientId] - 클라이언트 ID
   * @returns {string} 생성된 URL (에러 시 빈 문자열)
   */
  createUrl: function createUrl(_ref) {
    var webToken = _ref.webToken,
      clientId = _ref.clientId;
    var market = inpayLocale.getMarketFromWebToken(webToken);
    switch (market) {
      case inpayLocale.MARKET_ENUM.JPPC:
        return createJppcPurchaseHistoryUrl({
          clientId: clientId
        });
      default:
        console.error("Inpay: ".concat(market, " is not supported market for purchase history"));
        return '';
    }
  }
};

/**
 * JPPC 마켓의 구매내역 페이지 URL을 생성합니다.
 * 
 * @description
 * 클라이언트 ID 유무에 따라 JPPC 구매내역 페이지에서 노출하는 정보가 달라집니다.
 * - 클라이언트 ID 전달 시: 해당 게임 서비스별 구매내역 노출
 * - 클라이언트 ID 미전달 시: JPPC-INPAY 전체 구매내역 노출
 * 
 * @param {Object} params - URL 생성에 필요한 파라미터
 * @param {string} [params.clientId] - 클라이언트 ID
 * @returns {string} 생성된 URL
 */
var createJppcPurchaseHistoryUrl = function createJppcPurchaseHistoryUrl(_ref2) {
  var clientId = _ref2.clientId;
  var baseUrl = inpayEnv.JPPC_PURCHASE_HISTORY_ADDRESS;
  return clientId ? "".concat(baseUrl, "?client-id=").concat(clientId) : baseUrl;
};
export default purchaseHistory;